import script from "./whDOnceImg5_t2A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg5_t2A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg5_t2A.vue?vue&type=style&index=0&id=128cfc34&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128cfc34"]])

export default __exports__